<template>
  <div class="fallback__content">
    <h3 class="fallback-text">
      <slot />
    </h3>
  </div>
</template>

<script>
import {defineComponent} from "vue";

export default defineComponent({
  name: "ContentFallback"
});
</script>

<style scoped>
.fallback__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  height: 100%;
  margin: 0 auto;
  border-radius: 63% 37% 54% 46% / 55% 48% 52% 45%;
}

.fallback-text {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  color: #0e5377;
}

.fallback-text::before {
  content: "";
  display: block;
  background-image: url("../../../assets/static/nothing-found.svg");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 25vw;
  height: 12vw;
}

@media screen and (max-width: 875px) {
  .fallback__content {
    height: 40vw;
    width: 45vw;
  }

  .fallback-text::before {
    height: 23vh;
  }
}

@media screen and (max-width: 570px) {
  .fallback__content {
    width: 70vw;
    height: 60vw;
  }

  .fallback-text::before {
    height: 15vh;
  }

}

@media screen and (max-width: 325px) {
  .fallback__content {
    width: 90vw;
    height: 80vw;
  }
}
</style>
